import Client from './../Clients/axiosClient'
const resource = 'api/branches'

export default {
  get (payload) {
    return Client.get(`${resource}`, { params: payload })
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
}
